import * as esbuild from "esbuild-wasm";
import { CompileResult, SassOptions, SassStyle } from "../types";
import { FileSet } from "./esbuild-files-plugin";

const getStylesTag = (contents: string) => {
  // https://stackoverflow.com/a/34936253
  const escapedData = contents
    .replace(/[\r\n\x0B\x0C\u0085\u2028\u2029]+/g, "")
    .replace(/"/g, '\\"')
    .replace(/'/g, "\\'");

  const result = [
    `const style = document.createElement("style");`,
    `style.innerText = "${escapedData}";`,
    `document.head.appendChild(style);`
  ].join("\n");
  return result;
}

export const stylesPlugin = (
  sources: FileSet,
  compileSass?: (contents: string, options: SassOptions) => Promise<CompileResult>
): esbuild.Plugin => {
  return {
    name: "sandbox-styles-loader",
    setup(build: esbuild.PluginBuild) {

      //match css file
      build.onLoad({ filter: /\.css$/ }, async (args: esbuild.OnLoadArgs) => {
        const cssContents = sources[args.path];
        if (cssContents === undefined)
          return {
            errors: [{
              text: `File does not exists: ${args.path}`
            }]
          }

        const result: esbuild.OnLoadResult = {
          loader: "js",
          contents: getStylesTag(cssContents),
        };

        return result;
      });

      build.onLoad({ filter: /\.(scss|sass)$/ }, async (args: esbuild.OnLoadArgs) => {
        const cssContents = sources[args.path];
        if (cssContents === undefined)
          return {
            errors: [{
              text: `File does not exists: ${args.path}`
            }]
          }

        if (!compileSass) {
          return {
            errors: [{
              text: `Sass callback is not provided`
            }]
          }
        }

        const sassOptions: SassOptions = {
          style: SassStyle.compressed,
          indentedSyntax: args.path.endsWith(".sass"),
          sourceMapContents: true,
          sourceMapEmbed: true,
        };

        const result = await compileSass(cssContents, sassOptions);
        if (result.status === 0) {
          return {
            loader: "js",
            contents: getStylesTag(result.text || ""),
          };
        } else {
          return {
            errors: [{
              text: result.formatted,
              location: {
                column: result.column,
                line: result.line
              }
            }]
          }
        }
      });
    },
  };
};